angular.module('tasks')
    .controller('TimeSlotCollisionDialogController', function ($uibModalInstance, data) {
        this.$onInit = () => {
            this.timeSlotCheckResult = data;
        };
        this.cancel = () => $uibModalInstance.dismiss('Canceled');
        this.yes = () => $uibModalInstance.close();
    })
